"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelectInputChevronContainer = exports.StyledInput = exports.StyledSelectInputContainer = exports.Menu = exports.DisabledSelectedItemOverflow = exports.DefaultNoResultsDisplay = exports.VisibilityHidden = exports.SelectInput = exports.SimpleSelectValue = exports.SelectableItem = exports.UnfocusedInput = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_use_hoverintent_1 = require("react-use-hoverintent");
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../../theme");
var colors_1 = require("../../../theme/colors");
var flexbox_1 = require("../../flexbox");
var icon_button_1 = require("../../icon-button");
var icons_1 = require("../../icons");
var padding_1 = require("../../padding");
var popper_1 = require("../../popper");
var spacing_1 = require("../../spacing");
var spinner_1 = require("../../spinner");
var text_1 = require("../../text");
var tooltip_1 = require("../../tooltip");
function UnfocusedInput(_a) {
    var getToggleButtonProps = _a.getToggleButtonProps, isLoading = _a.isLoading, emptyPlaceholder = _a.emptyPlaceholder, renderUnfocusedInputToolbar = _a.renderUnfocusedInputToolbar, renderSelectedItem = _a.renderSelectedItem, renderSelectedItemHover = _a.renderSelectedItemHover, hasValue = _a.hasValue, isClearable = _a.isClearable, isOpen = _a.isOpen, onClear = _a.onClear;
    var _b = (0, react_use_hoverintent_1.useHoverIntent)({
        interval: 300,
        timeout: 200,
        sensitivity: 10,
    }), isHovering = _b[0], hoverRef = _b[1];
    return (react_1.default.createElement("div", { ref: hoverRef },
        react_1.default.createElement(popper_1.Popper, { isOpen: isHovering, placement: "bottom", trigger: function (_a) {
                var triggerRef = _a.triggerRef;
                return (react_1.default.createElement(SelectUnfocusedInput, (0, tslib_1.__assign)({}, getToggleButtonProps({ tabIndex: 0, ref: triggerRef }), { isClearable: !!hasValue && isClearable && !isOpen, onClear: function (e) {
                        e.stopPropagation();
                        onClear();
                    } }),
                    !hasValue ? (react_1.default.createElement(react_1.default.Fragment, null,
                        isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(spinner_1.CircleSpinnerInline, null),
                            react_1.default.createElement(spacing_1.Spacing, { width: 8 }))),
                        react_1.default.createElement(SelectPlaceholder, null, isLoading ? 'Loading...' : emptyPlaceholder))) : (renderSelectedItem()),
                    isOpen && (react_1.default.createElement(flexbox_1.Flexbox, { marginLeft: "auto", marginRight: 8 }, renderUnfocusedInputToolbar === null || renderUnfocusedInputToolbar === void 0 ? void 0 : renderUnfocusedInputToolbar()))));
            } }, hasValue && (renderSelectedItemHover === null || renderSelectedItemHover === void 0 ? void 0 : renderSelectedItemHover()))));
}
exports.UnfocusedInput = UnfocusedInput;
function SelectableItem(_a) {
    var getItemProps = _a.getItemProps, renderItem = _a.renderItem, renderItemHover = _a.renderItemHover, item = _a.item, isHovering = _a.isHovering, isSelected = _a.isSelected, index = _a.index, hasScrollbarOffset = _a.hasScrollbarOffset, getDisabledProps = _a.getDisabledProps;
    var disabled = getDisabledProps === null || getDisabledProps === void 0 ? void 0 : getDisabledProps(item, { index: index });
    return (react_1.default.createElement("div", (0, tslib_1.__assign)({}, getItemProps({
        item: item,
        index: index,
    })),
        react_1.default.createElement(popper_1.Popper, { portalElement: document.body, offsetDistance: hasScrollbarOffset ? 24 : 12, isOpen: !!renderItemHover && isHovering, placement: "right", trigger: function (_a) {
                var triggerRef = _a.triggerRef;
                return (react_1.default.createElement(DisabledSelectedItemOverflow, { enabled: disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled, message: disabled === null || disabled === void 0 ? void 0 : disabled.disabledMessage, tooltipProps: disabled === null || disabled === void 0 ? void 0 : disabled.disabledTooltipProps },
                    react_1.default.createElement("div", { ref: triggerRef }, renderItem(item, {
                        isHovering: isHovering,
                        isSelected: isSelected,
                        isDisabled: !!(disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled),
                    }))));
            } }, !(disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled) && (react_1.default.createElement("div", { role: "presentation", onClick: function (e) {
                e.stopPropagation();
            } }, renderItemHover === null || renderItemHover === void 0 ? void 0 : renderItemHover(item))))));
}
exports.SelectableItem = SelectableItem;
function SelectPlaceholder(_a) {
    var children = _a.children;
    return react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[300] }, children);
}
function SimpleSelectValue(_a) {
    var children = _a.children;
    return (react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[500], weight: 600, nowrap: true, truncate: true, textAlign: "left" }, children));
}
exports.SimpleSelectValue = SimpleSelectValue;
exports.SelectInput = (0, react_1.forwardRef)(function (_a, ref) {
    var assistiveText = _a.assistiveText, renderInputToolbar = _a.renderInputToolbar, inputRef = _a.inputRef, hasBorder = _a.hasBorder, props = (0, tslib_1.__rest)(_a, ["assistiveText", "renderInputToolbar", "inputRef", "hasBorder"]);
    var focusInput = function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var toolbar = renderInputToolbar === null || renderInputToolbar === void 0 ? void 0 : renderInputToolbar({ focusInput: focusInput });
    return (react_1.default.createElement(exports.StyledSelectInputContainer, { hasToolbar: !!toolbar, hasBorder: hasBorder },
        react_1.default.createElement("div", { style: {
                minWidth: 16,
                minHeight: 16,
                display: 'flex',
            } },
            react_1.default.createElement(icons_1.IconSearch2, { size: 16 })),
        react_1.default.createElement(exports.StyledInput, (0, tslib_1.__assign)({ ref: ref }, props)),
        assistiveText && (react_1.default.createElement(text_1.Text, { size: "small", color: colors_1.colors.steel[300], style: {
                marginRight: 8,
            } }, assistiveText)),
        toolbar ? (react_1.default.createElement(flexbox_1.Flexbox, { marginLeft: "auto" }, toolbar)) : (react_1.default.createElement(exports.StyledSelectInputChevronContainer, null,
            react_1.default.createElement(icons_1.IconArrowDropDown, null)))));
});
var SelectUnfocusedInput = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, isClearable = _a.isClearable, onClear = _a.onClear, clearButtonRef = _a.clearButtonRef, props = (0, tslib_1.__rest)(_a, ["children", "isClearable", "onClear", "clearButtonRef"]);
    return (react_1.default.createElement(exports.StyledSelectInputContainer, (0, tslib_1.__assign)({ as: "button", type: "button", ref: ref }, props),
        children,
        react_1.default.createElement(exports.StyledSelectInputChevronContainer, null,
            isClearable && (react_1.default.createElement(icon_button_1.IconButton, { type: "close", ariaLabel: "clear selection", onClick: onClear, innerRef: clearButtonRef })),
            react_1.default.createElement(icons_1.IconArrowDropDown, null))));
});
function VisibilityHidden(_a) {
    var children = _a.children, enabled = _a.enabled;
    return (react_1.default.createElement("div", { style: enabled
            ? {
                visibility: 'hidden',
                display: 'none',
            }
            : undefined }, children));
}
exports.VisibilityHidden = VisibilityHidden;
function DefaultNoResultsDisplay() {
    return (react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "center", alignItems: "center" },
        react_1.default.createElement(padding_1.Padding, { size: 20 },
            react_1.default.createElement(text_1.Text, { weight: 500, color: colors_1.colors.steel[400] }, "No results"))));
}
exports.DefaultNoResultsDisplay = DefaultNoResultsDisplay;
function DisabledSelectedItemOverflow(_a) {
    var children = _a.children, enabled = _a.enabled, message = _a.message, tooltipProps = _a.tooltipProps;
    if (!enabled) {
        return children;
    }
    return (react_1.default.createElement(tooltip_1.Tooltip, (0, tslib_1.__assign)({ message: message }, tooltipProps),
        react_1.default.createElement("div", { style: {
                position: 'relative',
                cursor: 'not-allowed',
                background: colors_1.colors.steel[50],
                opacity: '0.4',
            } }, children)));
}
exports.DisabledSelectedItemOverflow = DisabledSelectedItemOverflow;
exports.Menu = (0, react_1.forwardRef)(function (_a, ref) {
    var isLoading = _a.isLoading, isOpen = _a.isOpen, children = _a.children, header = _a.header, footer = _a.footer, overflowRef = _a.overflowRef, rest = (0, tslib_1.__rest)(_a, ["isLoading", "isOpen", "children", "header", "footer", "overflowRef"]);
    return (react_1.default.createElement("div", (0, tslib_1.__assign)({ ref: ref }, rest),
        header,
        react_1.default.createElement("div", { ref: overflowRef, style: {
                maxHeight: 500,
                overflow: 'auto',
            } }, isOpen && (react_1.default.createElement(react_1.default.Fragment, null, isLoading ? (react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "center" },
            react_1.default.createElement(padding_1.Padding, { size: 20 },
                react_1.default.createElement(spinner_1.CircleSpinnerInline, null)))) : (children)))),
        footer));
});
exports.StyledSelectInputContainer = styled_components_1.default.div(function (_a) {
    var hasToolbar = _a.hasToolbar, _b = _a.hasBorder, hasBorder = _b === void 0 ? true : _b;
    return ({
        outline: 0,
        ':focus': {
            borderColor: colors_1.colors.brand[400],
        },
        background: '#fff',
        flex: 1,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        color: colors_1.colors.steel[400],
        boxSizing: 'border-box',
        border: hasBorder ? "1px solid ".concat(colors_1.colors.steel[200]) : undefined,
        borderBottom: !hasBorder ? "1px solid ".concat(colors_1.colors.steel[200]) : undefined,
        padding: '8px 40px 8px 16px',
        paddingRight: hasToolbar ? '16px' : '40px',
        borderRadius: hasBorder ? 4 : undefined,
        height: 40,
        '&:disabled': {
            background: colors_1.colors.steel[50],
        },
        '&:not(:disabled)': {
            cursor: 'pointer',
        },
    });
});
exports.StyledInput = styled_components_1.default.input({
    display: 'flex',
    flex: 1,
    width: '100%',
    paddingLeft: 8,
    boxSizing: 'border-box',
    border: 0,
    boxShadow: 'none',
    outline: 0,
    ':focus': {
        borderColor: colors_1.colors.brand[400],
    },
    fontFamily: theme_1.fontFamilies.body,
    fontSize: theme_1.fontSizes.regular.fontSize,
    color: colors_1.colors.steel[500],
    '::placeholder': {
        color: colors_1.colors.steel[300],
    },
});
exports.StyledSelectInputChevronContainer = styled_components_1.default.div({
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
});
//# sourceMappingURL=index.js.map